/** A complete, authorized snapshot gives tables and exports the same scope and count. */
export function snapshotSelection(rows, query, matches) {
  const term = query.get("search")?.trim();
  let selected = term ? rows.filter((row) => matches(row, term)) : [...rows];
  const filters = new Map(), order = new Map();
  query.forEach((value, key) => {
    const match = key.match(/^(filter|sort)\[(\d+)\]\[(\w+)\]$/);
    if (!match) return;
    const map = match[1] === "filter" ? filters : order;
    const item = map.get(match[2]) || {}; item[match[3]] = value; map.set(match[2], item);
  });
  for (const { key, value, operator } of filters.values()) {
    if (!key || key === "defaultFilter") continue;
    selected = selected.filter((row) => {
      const actual = row[key];
      const text = String(actual ?? "").toLocaleLowerCase(), expected = String(value).toLocaleLowerCase();
      switch (operator) {
        case "eq": return value === "null" ? actual == null : text === expected;
        case "neq": case "ne": return text !== expected;
        case "gt": return Number(actual) > Number(value);
        case "gte": return Number(actual) >= Number(value);
        case "lt": return Number(actual) < Number(value);
        case "lte": return Number(actual) <= Number(value);
        case "contains": case "like": case "lk": return text.includes(expected);
        default: throw new Error("این نوع فیلتر در نمای جدول پشتیبانی نمی‌شود.");
      }
    });
  }
  if (order.size) selected.sort((left, right) => {
    for (const { key, direction } of order.values()) {
      const a = left[key], b = right[key];
      const difference = typeof a === "number" && typeof b === "number" ? a - b : String(a ?? "").localeCompare(String(b ?? ""));
      if (difference) return direction === "desc" ? -difference : difference;
    }
    return 0;
  });
  return selected;
}

export function createSnapshotPageSource({ load, matches, header, normalize = (row) => row }) {
  let snapshot;
  async function read(config = {}) {
    config.cancelToken?.throwIfRequested();
    if (!snapshot) {
      const result = await load(config);
      config.cancelToken?.throwIfRequested();
      snapshot = { ...result, data: result.data.map(normalize) };
    }
    return snapshot;
  }
  return {
    async requestPage(url, config) {
      const query = new URL(url).searchParams;
      const result = await read(config);
      const data = snapshotSelection(result.data, query, matches);
      const page = Math.max(1, Number(query.get("Page")) || 1), limit = Math.max(1, Number(query.get("Limit")) || 50);
      return { data: { ...result, header: result.header || header, data: data.slice((page - 1) * limit, page * limit),
        meta: { total: data.length, total_pages: Math.max(1, Math.ceil(data.length / limit)) } } };
    },
    async requestExport(api, extra, ids, temp) {
      const result = await read();
      let data = snapshotSelection(result.data, new URLSearchParams(String(temp || "").replace(/^[?&]/, "")), matches);
      if (ids) { const allowed = new Set(ids.replace(/^,/, "").split(",")); data = data.filter((row) => allowed.has(String(row.id))); }
      const columns = (result.header || header).filter((column) => column.showInList && !column.showInExtra);
      return { data: { code: 200, data: { header: columns.map((column) => column.title), body: data.map((row) => columns.map((column) => {
        const value = column.type === "objectfield" ? row[column.name]?.[column.link] : row[column.name];
        return value && typeof value === "object" ? JSON.stringify(value) : value ?? "";
      })) } } };
    },
  };
}
